import React, { Fragment, useState } from 'react';

import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
  Alert
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEquals, faTimes } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import ButtonIcon from '../../common/ButtonIcon';
import Switch from 'react-switch';

import ComponentFilter from './ComponentFilter';
import CategoryFilter from './CategoryFilter';
// Managed product components
import PropTypes from 'prop-types';
import VendorMultiSelect from './VendorMultiSelect';
import Checkbox from '../../common/Checkbox';

export default function ProductPriority({
  vendorId,
  vendorLabel,
  vendorPriorityOptions,
  vendorStatusOptions = [],
  vendorSupportStatusOptions = [],
  vendorResolutionOptions = [],
  vendorBugCategoryOptions = [],
  vendorBugTypeOptions = [],
  vendorBugTypes = [],
  vendorBugCategories = [],
  setVendorBugTypes,
  setVendorBugCategories,
  // fortinetBugCategories,
  // setFortinetBugCategories,
  setVendorResolutions = [],
  setVendorStatuses,
  setVendorSupportStatus,
  vendorStatuses = [],
  vendorSupportStatus = [],
  setVendorProductBugCategories,
  vendorProductBugCategories = [],
  vendorProductBugCategoryOptions,
  vendorResolutions = [],
  isSubmitted,
  priorityMaps,
  setPriorityMaps,
  snPriorityOptions,
  title,
  keywords = [],
  setKeywords,
  includedComponents = [],
  setIncludedComponents,
  excludedComponents,
  setExcludedComponents,
  searchFields,
  setSearchFields,
  vendorBugServiceOptions,
  setVendorBugServices,
  vendorBugServices,
  // vendorEventLevelOptions,
  // vendorEventLevels,
  // setVendorEventLevels,
  loader,
  setLoader,
  setQuery,
  query,
  offset,
  limit,
  // supportCasesCount,
  // setCases,
  isCve,
  setIsCve,
  vendorImpactedRegions,
  setVendorImpactedRegions,
  vendorImpactedRegionOptions,
  requireImpactedRegions = true,
  vendorComplianceStatus,
  setVendorComplianceStatus,
  vendorComplianceStatusOptions,
  vendorRiskCategoryOptions,
  vendorRiskCategories,
  setVendorRiskCategories,
  vendorMitigationTypes,
  setVendorMitigationTypes,
  vendorMitigationTypeOptions,
  enableChatGptPriority
}) {
  // debug
  const [keyword, setKeyword] = useState('');
  const [kwError, setKwError] = useState('');

  const selectStyles = {
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: isFocused || isSelected ? 'white' : 'var(--ink)'
      };
    },
    menuPortal: base => ({ ...base, zIndex: 9999 })
  };

  // Generic function to handle react-select single/multi-selects
  function handleSelectChange(e, setHook) {
    const selected = e || [];
    if (Array.isArray(selected)) setHook(selected.map(el => el));
    else setHook(selected);
  }

  // Priority
  const blankPriority = { vendorPriority: null, snPriority: null };
  const addPriority = () => {
    setPriorityMaps([...priorityMaps, { ...blankPriority }]);
  };
  const removePriority = idx => {
    priorityMaps.splice(idx, 1);
    setPriorityMaps([...priorityMaps]);
  };
  const handleCatChange = (e, idx, field) => {
    const selectedOption = e;
    const updatedPriorities = [...priorityMaps];
    updatedPriorities[idx][field] = selectedOption;
    setPriorityMaps(updatedPriorities);
  };

  const addKeyword = () => {
    const k = { value: keyword, label: keyword };
    const duplicate = keywords.filter(kw => kw.label === k.label).length ? true : false;
    if (!duplicate && k.value.length > 0) {
      setKeywords([...keywords, k]);
      setKeyword('');
      setKwError('');
      console.log('keywords', keywords);
    }
    if (duplicate) {
      setKwError('Keyword already in the excluded list.');
    }
  };
  const removeKeyword = e => {
    setKeywords(keywords.filter(k => k.value !== e.target.id));
  };
  const handleKeywordChange = e => {
    const k = e.target.value;
    setKeyword(k);
  };

  function handleToggleSearch(index, enabled) {
    searchFields[index].enabled = enabled;

    setSearchFields([...searchFields]);
  }

  // function to post to reusable API endpoint for disclaimer agreements

  return (
    <Card bg={''} text={'dark'} style={{}} className="mb-4">
      <CardBody>
        <Row>
          {isCve !== undefined ? (
            <Col lg="5" className="mb-4">
              <div>
                <CardTitle>Filter CVE Bugs</CardTitle>
                <CardText>Choose whether or not to include CVE bugs</CardText>
                <div className="">
                  <Switch
                    id={'cve-toggle-switch'}
                    onChange={e => setIsCve(isCve !== undefined ? !isCve : undefined)}
                    checked={isCve}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#253746"
                    className=""
                    height={20}
                    width={40}
                    handleDiameter={16}
                  />
                  <Label className="ml-2">If enabled, CVE bugs will be excluded</Label>
                </div>
              </div>
            </Col>
          ) : (
            ''
          )}

          {vendorStatusOptions?.length && !vendorStatusOptions[0]?.hasOwnProperty('variables') ? (
            <>
              <Col lg="5" className={`${isCve !== undefined ? 'offset-lg-1' : ''} "mb-4"`}>
                <CardTitle data-testid={'bug-statuses-title'}>Select Bug Statuses to Monitor</CardTitle>
                <CardText>Select multiple entries if necessary</CardText>
                <VendorMultiSelect
                  options={vendorStatusOptions}
                  setHook={setVendorStatuses}
                  categories={vendorStatuses}
                  handleSelectChange={handleSelectChange}
                  isSubmitted={isSubmitted}
                  feedback={'a status'}
                  name={'Bug Statuses'}
                  required={true}
                />
              </Col>
            </>
          ) : (
            ''
          )}
          {/* {!!vendorEventLevels?.length || vendorEventLevelOptions?.length ? (
            <Col lg="5" className={`${vendorStatusOptions?.length && isCve === undefined ? 'offset-lg-1' : ''} "mb-4"`}>
              <CardTitle data-testid={'events-levels-title'}>Select Event Levels to Monitor</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorEventLevelOptions}
                setHook={setVendorEventLevels}
                categories={vendorEventLevels}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a level'}
                name={'Event Levels'}
                required={true}
              />
            </Col>
          ) : (
            ''
          )} */}
          {setVendorSupportStatus && vendorSupportStatusOptions?.length ? (
            <>
              <Col lg="5" className={`mb-4`}>
                <CardTitle data-testid={'bug-statuses-title'}>Select Vendor Support Statuses to Monitor</CardTitle>
                <CardText>Select multiple entries if necessary</CardText>
                <VendorMultiSelect
                  options={vendorSupportStatusOptions}
                  setHook={setVendorSupportStatus}
                  categories={vendorSupportStatus}
                  handleSelectChange={handleSelectChange}
                  isSubmitted={isSubmitted}
                  feedback={'a support status'}
                  name={'Bug Support Statuses'}
                  required={true}
                />
              </Col>
            </>
          ) : (
            ''
          )}

          {!!vendorImpactedRegions?.length || vendorImpactedRegionOptions?.length ? (
            <Col lg="5" className="">
              <CardTitle>Select Impacted Regions to Monitor</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorImpactedRegionOptions}
                setHook={setVendorImpactedRegions}
                categories={vendorImpactedRegions}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a region'}
                name={'Impacted Regions'}
                required={requireImpactedRegions}
              />
            </Col>
          ) : (
            ''
          )}

          {!!vendorRiskCategories?.length || vendorRiskCategoryOptions?.length ? (
            <Col
              lg="5"
              className={`${
                vendorImpactedRegionOptions?.length || vendorStatusOptions?.length || isCve !== undefined
                  ? 'offset-lg-1'
                  : ''
              }`}
            >
              <CardTitle>Select Risk Categories to Monitor</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorRiskCategoryOptions}
                setHook={setVendorRiskCategories}
                categories={vendorRiskCategories}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a risk'}
                name={'Risk Categories'}
                required={true}
              />
            </Col>
          ) : (
            ''
          )}
          {!!vendorMitigationTypes?.length || vendorMitigationTypeOptions?.length ? (
            <Col lg="5">
              <CardTitle>
                Select Mitigation Types to Monitor <span style={{ color: '#bd472a' }}>*</span>
              </CardTitle>
              <CardText>Select one or multiple types</CardText>
              <VendorMultiSelect
                options={vendorMitigationTypeOptions}
                setHook={setVendorMitigationTypes}
                categories={vendorMitigationTypes}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a mitigation type'}
                name={'Mitigation Types'}
                required={false}
              />
            </Col>
          ) : (
            ''
          )}
          {/* {vendorId === 'cisco' ? (
            <Col lg="5" className="offset-lg-1">
              <div>
                <CardTitle data-testid={'support-cases-title'}>Minimum Support Cases Count</CardTitle>
                <CardText>Select the minimum support cases a defect should have to be included</CardText>
                <div className="">
                  <Switch
                    id={'support-cases-switch'}
                    onChange={e => handleSwitchToggle(e)}
                    checked={isCasesOn}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#253746"
                    className=""
                    height={20}
                    width={40}
                    handleDiameter={16}
                    data-testid={'support-cases-switch'}
                  />
                </div>

                <Input
                  type="number"
                  className="w-50"
                  value={parseFloat(supportCasesCount).toFixed(0)}
                  onChange={e => changeCases(e)}
                  disabled={!isCasesOn}
                  min={0}
                  step={1}
                  data-testid={'support-cases-input'}
                />
              </div>
            </Col>
          ) : (
            ''
          )} */}
        </Row>
        {!!includedComponents.length ? (
          <ComponentFilter
            vendorId={vendorId}
            vendorLabel={vendorLabel}
            loader={loader}
            setLoader={setLoader}
            setQuery={setQuery}
            query={query}
            offset={offset}
            limit={limit}
            includedComponents={includedComponents}
            setIncludedComponents={setIncludedComponents}
            excludedComponents={excludedComponents}
            setExcludedComponents={setExcludedComponents}
          />
        ) : (
          ''
        )}
        {!!vendorProductBugCategories?.length || vendorProductBugCategoryOptions?.length ? (
          <>
            <CategoryFilter
              vendorId={vendorId}
              vendorLabel={vendorLabel}
              loader={loader}
              setLoader={setLoader}
              vendorProductBugCategoryOptions={vendorProductBugCategoryOptions}
              vendorProductBugCategories={vendorProductBugCategories}
              setVendorProductBugCategories={setVendorProductBugCategories}
              excludedComponents={excludedComponents}
              setExcludedComponents={setExcludedComponents}
            />
            <br />
          </>
        ) : (
          ''
        )}
        {!!vendorBugServiceOptions?.length || vendorBugServices?.length ? (
          <>
            <CategoryFilter
              vendorId={vendorId}
              vendorLabel={vendorLabel}
              loader={loader}
              setLoader={setLoader}
              vendorBugServiceOptions={vendorBugServiceOptions}
              vendorBugServices={vendorBugServices}
              setVendorBugServices={setVendorBugServices}
              excludedComponents={excludedComponents}
              setExcludedComponents={setExcludedComponents}
            />
            <br />
          </>
        ) : (
          ''
        )}
        {/* Add conditional based on search_fields to display this component */}
        <div className="mb-4">
          <CardTitle data-testid={'kw-exclude-title'}>Keywords to Exclude</CardTitle>
          <Row>
            <Col md={5}>
              <CardText>Add multiple entries if necessary</CardText>
              <p className="text-danger">{kwError}</p>
              <Input
                type="text"
                name="keyword"
                id="keyword"
                placeholder="Add keyword"
                value={keyword}
                onChange={e => handleKeywordChange(e)}
                onKeyDown={e => (e.key === 'Enter' ? addKeyword() : null)}
                data-testid={'kw-input'}
              />
              <div className="d-flex justify-content-end mt-2">
                <ButtonIcon
                  onClick={addKeyword}
                  color="falcon-default"
                  size="sm"
                  icon="plus"
                  iconClassName="fs--2"
                  data-testid={'kw-add-btn'}
                >
                  Add
                </ButtonIcon>
              </div>
            </Col>
            <Col className="ml-3">
              {searchFields?.length ? (
                <div className="d-flex align-items-center flex-wrap gap-3 mb-2">
                  <CardText className="mb-0">Include in keyword search:</CardText>
                  {searchFields.map(({ value, label, enabled }, index) => (
                    <Checkbox
                      key={value}
                      checked={!!enabled}
                      onChange={() => handleToggleSearch(index, enabled ? 0 : 1)}
                      label={label}
                      data-testid={label + '-checkbox'}
                    />
                  ))}
                </div>
              ) : (
                ''
              )}
              <div className="border rounded p-2 mh-10 bg-white">
                <div className="d-flex flex-wrap" data-testid={'kwds'}>
                  {keywords && keywords.length > 0 ? (
                    keywords.map(keyword => {
                      return (
                        <div key={keyword.value} className="my-1 mr-2">
                          <div className="kw-chip d-inline-flex align-items-center">
                            <span>{keyword.label}</span>
                            <span className="kw-chip-close" id={keyword.label} onClick={e => removeKeyword(e)}>
                              &times;
                            </span>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <span className="text-muted p-2">No keywords have been selected</span>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <Row>
          {!!vendorBugTypeOptions?.length && (
            <Col lg="5">
              <CardTitle data-testid={'bug-types-title'}>Select Bug Types to Monitor</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorBugTypeOptions}
                setHook={setVendorBugTypes}
                categories={vendorBugTypes}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a type'}
                name={'Bug Types'}
                required={true}
              />
            </Col>
          )}
          {!!vendorComplianceStatus?.length || vendorComplianceStatusOptions?.length ? (
            <Col lg="5">
              <CardTitle>Select Compliance Status</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorComplianceStatusOptions}
                setHook={setVendorComplianceStatus}
                categories={vendorComplianceStatus}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a compliance status'}
                name={'Compliance Status'}
                required={true}
              />
            </Col>
          ) : (
            ''
          )}
          {!!vendorBugCategoryOptions?.length && vendorId !== 'fortinet' && (
            <Col lg="5" className={`${vendorBugTypeOptions.length && 'offset-lg-1'} ''`}>
              <CardTitle data-testid={'bug-categories-title'}>Select Bug Categories to Monitor</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorBugCategoryOptions}
                setHook={setVendorBugCategories}
                categories={vendorBugCategories}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a category'}
                name={'Bug Categories'}
                required={true}
              />
            </Col>
          )}
        </Row>
        {!!vendorResolutionOptions?.length && (
          <>
            <CardTitle data-testid={'bug-resolutions-title'}>Select Bug Resolutions to Monitor</CardTitle>
            <CardText>Select multiple entries if necessary</CardText>
            <Row>
              <Col lg="5">
                <VendorMultiSelect
                  options={vendorResolutionOptions}
                  setHook={setVendorResolutions}
                  categories={vendorResolutions}
                  handleSelectChange={handleSelectChange}
                  isSubmitted={isSubmitted}
                  feedback={'a resolution'}
                  name={'Bug Resolutions'}
                  required={false}
                />
              </Col>
            </Row>
            <br />
          </>
        )}
        <CardTitle data-testid={'priorities-title'}>
          Map Vendor Severity to ServiceNow Priority
          <span style={{ color: '#bd472a' }}>*</span>
        </CardTitle>
        <CardText>Specify which severities and priorities to monitor</CardText>
        {/* ADD IF ENABLE TO REMOVE FROM MANAGED PRODUCTS */}

        {!!priorityMaps?.length && (
          <Fragment>
            <Row>
              <Col lg={5}>
                <FormGroup>
                  <Label>Vendor Severity</Label>
                </FormGroup>
              </Col>
              <Col lg={1}>
                <FormGroup style={{ textAlign: 'center', marginTop: '38px' }} />
              </Col>
              <Col lg={5}>
                <FormGroup>
                  <Label>ServiceNow Impact / Urgency / Priority</Label>
                </FormGroup>
              </Col>
            </Row>
          </Fragment>
        )}
        {/* Priority */}
        {priorityMaps?.map((val, idx) => {
          const vendorPriority = `vendor-${idx}`;
          const snPriority = `snPriority-${idx}`;
          return (
            <Fragment key={`priority-${idx}`}>
              <Row>
                <Col md={5}>
                  <FormGroup>
                    <div data-testid={'severity-select'}>
                      <Select
                        id={vendorPriority}
                        name={vendorPriority}
                        value={priorityMaps[idx].vendorPriority}
                        onChange={e => handleCatChange(e, idx, 'vendorPriority')}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        options={
                          enableChatGptPriority
                            ? vendorPriorityOptions
                                ?.filter(o => {
                                  return o.hasOwnProperty('isCustom') ? o.isCustom : true;
                                })
                                ?.filter(vendorPriorityOption => {
                                  // Filter out values already set
                                  const result = priorityMaps.filter(e => {
                                    if (!e.vendorPriority) {
                                      return false;
                                    }
                                    return e.vendorPriority.value === vendorPriorityOption.value;
                                  });
                                  return result.length ? false : true;
                                })
                            : vendorPriorityOptions
                                ?.filter(o => {
                                  return !o.isCustom;
                                })
                                ?.filter(vendorPriorityOption => {
                                  // Filter out values already set
                                  const result = priorityMaps.filter(e => {
                                    if (!e.vendorPriority) {
                                      return false;
                                    }
                                    return e.vendorPriority.value === vendorPriorityOption.value;
                                  });
                                  return result.length ? false : true;
                                })
                        }
                        theme={theme => ({
                          ...theme,
                          borderRadius: 5,
                          colors: {
                            ...theme.colors,
                            // text: 'white',
                            primary25: '#253746',
                            primary: '#253746'
                            // neutral80: 'white'
                          }
                        })}
                        styles={selectStyles}
                        required
                      />
                    </div>
                    <FormFeedback
                      className={!priorityMaps[idx].vendorPriority && isSubmitted ? 'd-block' : ''}
                      type="invalid"
                      data-testid={'severity-feedback'}
                    >
                      Please select a priority.
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup style={{ textAlign: 'center', marginTop: '7px' }}>
                    <FontAwesomeIcon icon={faEquals} color={'#253746'} />
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <div data-testid={'priority-select'}>
                      <Select
                        id={snPriority}
                        name={snPriority}
                        value={priorityMaps[idx].snPriority}
                        onChange={e => handleCatChange(e, idx, 'snPriority')}
                        options={snPriorityOptions}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        required
                        theme={theme => ({
                          ...theme,
                          borderRadius: 5,
                          colors: {
                            ...theme.colors,
                            // text: 'white',
                            primary25: '#253746',
                            primary: '#253746'
                            // neutral0: 'white',
                            // neutral80: 'white'
                          }
                        })}
                        styles={selectStyles}
                      />
                    </div>
                    <FormFeedback
                      className={!priorityMaps[idx].snPriority && isSubmitted ? 'd-block' : ''}
                      type="invalid"
                      data-testid={'priority-feedback'}
                    >
                      Please select a priority.
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup style={{ textAlign: 'center', marginTop: '7px' }}>
                    <FontAwesomeIcon
                      icon={faTimes}
                      color={'#9b9b9b'}
                      size="lg"
                      style={{ cursor: 'pointer' }}
                      onClick={() => removePriority(idx)}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Fragment>
          );
        })}
        <Row>
          <Col lg="5">
            <FormGroup>
              <FormFeedback className={!priorityMaps?.length && isSubmitted ? 'd-block' : ''} type="invalid">
                <Alert color="danger" fade={false}>
                  Please add a priority.
                </Alert>
              </FormFeedback>
            </FormGroup>
            <FormGroup className="d-flex justify-content-end">
              <ButtonIcon
                onClick={addPriority}
                color="falcon-default"
                size="sm"
                icon="plus"
                iconClassName="fs--2"
                data-testid={'add-priority-btn'}
              >
                Add priority
              </ButtonIcon>
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

ProductPriority.propTypes = {
  vendorId: PropTypes.string,
  vendorPriorityOptions: PropTypes.array,
  vendorStatusOptions: PropTypes.array,
  vendorSupportStatusOptions: PropTypes.array,
  vendorBugCategoryOptions: PropTypes.array,
  vendorBugTypeOptions: PropTypes.array,
  handleSelectChange: PropTypes.func,
  setVendorStatuses: PropTypes.func,
  setVendorSupportStatus: PropTypes.func,
  setVendorProductBugCategories: PropTypes.func,
  vendorBugTypes: PropTypes.array,
  vendorBugCategories: PropTypes.array,
  fortinetBugCategories: PropTypes.array,
  setFortinetBugCategories: PropTypes.func,
  setVendorBugTypes: PropTypes.func,
  setVendorBugCategories: PropTypes.func,
  vendorResolutionOptions: PropTypes.array,
  setVendorResolutions: PropTypes.func,
  vendorResolutions: PropTypes.array,
  vendorStatuses: PropTypes.array,
  vendorSupportStatus: PropTypes.array,
  vendorProductBugCategories: PropTypes.array,
  isSubmitted: PropTypes.bool,
  priorityMaps: PropTypes.array,
  snPriorityOptions: PropTypes.array,
  setPriorityMaps: PropTypes.func,
  title: PropTypes.string,
  keywords: PropTypes.array,
  setKeywords: PropTypes.func,
  includedComponents: PropTypes.array,
  setIncludedComponents: PropTypes.func,
  excludedComponents: PropTypes.array,
  setExcludedComponents: PropTypes.func,
  searchFields: PropTypes.array,
  setSearchFields: PropTypes.func,
  vendorProductBugCategoryOptions: PropTypes.array,
  vendorBugServiceOptions: PropTypes.array,
  setVendorBugServices: PropTypes.func,
  vendorBugServices: PropTypes.array,
  // vendorEventLevelOptions: PropTypes.array,
  // vendorEventLevels: PropTypes.array,
  // setVendorEventLevels: PropTypes.func,
  vendorLabel: PropTypes.string,
  loader: PropTypes.bool,
  setLoader: PropTypes.func,
  setQuery: PropTypes.func,
  query: PropTypes.string,
  offset: PropTypes.string,
  limit: PropTypes.string,
  // supportCasesCount: PropTypes.number,
  // setCases: PropTypes.func,
  isCve: PropTypes.bool,
  setIsCve: PropTypes.func,
  vendorImpactedRegions: PropTypes.array,
  setVendorImpactedRegions: PropTypes.func,
  vendorImpactedRegionOptions: PropTypes.array,
  requireImpactedRegions: PropTypes.bool,
  vendorComplianceStatus: PropTypes.array,
  setVendorComplianceStatus: PropTypes.func,
  vendorComplianceStatusOptions: PropTypes.array,
  setVendorRiskCategories: PropTypes.func,
  vendorRiskCategories: PropTypes.array,
  vendorRiskCategoryOptions: PropTypes.array,
  vendorMitigationTypes: PropTypes.array,
  setVendorMitigationTypes: PropTypes.func,
  vendorMitigationTypeOptions: PropTypes.array,
  enableChatGptPriority: PropTypes.bool,
  setEnableChatGptPriority: PropTypes.func,
  aiAgree: PropTypes.bool,
  setAiAgree: PropTypes.func
};
